import React from 'react'
import { OutboundLink } from 'gatsby-plugin-gtag'

// Gets rid of ref warning when using for composition with MUI
const ForwardOutboundLink = React.forwardRef((props, ref) => (
  <OutboundLink {...props} />
))

export default ForwardOutboundLink
